module.exports = __webpack_public_path__ + "img/the-netherlands-cardiovascular-diseases-male.955dde76.png";